module.exports = __webpack_public_path__ + "static/img/1441_phase_function_Paper_PointsHejduk_Prediction.be98d8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1441_phase_function_Paper_PointsHejduk_Prediction.png
// module id = OHvp
// module chunks = 0